import { render, staticRenderFns } from "./NumbersComponent.vue?vue&type=template&id=2cb450f2"
import script from "./NumbersComponent.vue?vue&type=script&lang=ts"
export * from "./NumbersComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports